import { Button } from '@rocketlane/ui';
// import { Tabs } from 'rocket-ui';
// import { Tabs as AntTabs } from 'antd';
import styled from 'styled-components';

const GutterGapSize = {
  '1': 'var(--spacing-01)',
  '2': 'var(--spacing-02)',
  '3': 'var(--spacing-03)',
  '4': 'var(--spacing-04)',
  '5': 'var(--spacing-05)',
  '6': 'var(--spacing-06)',
} as const;

interface GutterProps {
  size: keyof typeof GutterGapSize;
}

export const FlexWrapper = styled.div`
  display: flex;
`;

export const FlexWrapperAlignCenter = styled(FlexWrapper)`
  align-items: center;
`;

export const FlexWrapperJustifyBetween = styled(FlexWrapper)`
  justify-content: space-between;
`;

export const FlexWrapperWithGutter = styled(FlexWrapper)`
  gap: var(--spacing-03);
`;

export const FlexWrapperWithGutterSize = styled(
  FlexWrapperWithGutter,
)<GutterProps>`
  gap: ${({ size }) => GutterGapSize[size]};
`;

export const FlexWrapperWithColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

/**
 * Flex Wrapper with gap.
 * @description This is a styled component that is used to create a flex wrapper with a gap of 0.5rem (var(--spacing-03)).
 * @param {React.ReactNode} props.children - The children of the flex wrapper.
 * @returns {React.ReactNode} The flex wrapper with the gap.
 */
export const FlexWrapperWithShortGap = styled(FlexWrapperAlignCenter)`
  gap: var(--spacing-03);
`;

export const FlexWrapperWithShortGapColumn = styled(FlexWrapperWithColumn)`
  gap: 2px;
`;

/**
 * Flex Wrapper with justify content between.
 * @description This is a styled component that is used to create a flex wrapper with a justify content of space-between.
 * @param {React.ReactNode} props.children - The children of the flex wrapper.
 * @returns {React.ReactNode} The flex wrapper with the justify content of space-between.
 */
export const FlexWrapperWithJustifyBetween = styled(FlexWrapper)`
  justify-content: space-between;
`;

export const FilterButton = styled(Button)`
  font-weight: var(--font-weight-bold);
`;

export const RightPaddingBase = styled.div`
  padding-right: var(--spacing-05);
`;

// Use this to wrap icon and text
export const IconWrapper = styled(FlexWrapperAlignCenter)`
  gap: var(--spacing-03);
`;

export const CenterAlign = styled(FlexWrapperAlignCenter)`
  justify-content: center;
  width: 100%;
  height: 100%;
`;

// export const TabsWrapper = styled(Tabs)`
//   .ant-tabs-content-holder {
//     padding: 0 var(--spacing-06);
//   }
//   /* padding: 0 var(--spacing-05); */
// `;
